module.exports = __webpack_public_path__ + "img/logo_new.c31fd968.png";